<template>
    <Keep-alive>
        <router-view/>
    </Keep-alive>
    
</template>
<script>
export default {
    name:'finance-layout'
}
</script>